// src/pages/shared/DoctorSalutationDropdown.jsx
import React from "react";
import TextFieldDropdown from "@/pages/shared/TextFieldDropdown.jsx";

export default function DoctorSalutationDropdown(props) {
  return <TextFieldDropdown {...props} />;
}
